import { initializeApp, setLogLevel } from "firebase/app";
import { getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};
const app = getApps().length < 1 ? initializeApp(firebaseConfig) : getApp();
if (process.env.NEXT_PUBLIC_APP_ENV === "development") {
    setLogLevel("info");
}
if (!app) {
    throw new Error('Firebase initialization error');
}
const firestore = getFirestore(app, 'consumer');
const storage = getStorage(app, 'autovinsights-consumer');
const database = getDatabase(app);
const auth = getAuth(app);
export { firestore, storage, database, auth };
